<ng-template #settingsTemplate></ng-template>
<ng-template #contentTemplate>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 305.64 762.79"
    >
        <defs>
            <style>
                .traffic-light-1 {
                    mask: url(#mask);
                }
                .traffic-light-2,
                .traffic-light-4,
                .traffic-light-5 {
                    mix-blend-mode: multiply;
                }
                .traffic-light-2 {
                    fill: url(#linear-gradient);
                }
                .traffic-light-3 {
                    mask: url(#mask-2);
                }
                .traffic-light-4 {
                    fill: url(#linear-gradient-2);
                }
                .traffic-light-5 {
                    fill: url(#linear-gradient-3);
                }
                .traffic-light-6 {
                    fill: #afacad;
                }
                .traffic-light-7 {
                    fill: #2a2a29;
                }
                .traffic-light-8 {
                    fill: url(#Nieuwe_verloopstaal_1);
                }
                .traffic-light-9 {
                    fill: url(#Nieuwe_verloopstaal_2);
                }
                .traffic-light-10 {
                    fill: url(#Nieuwe_verloopstaal_4);
                }
                .traffic-light-11 {
                    mask: url(#mask-4);
                }
                .traffic-light-12 {
                    fill: url(#linear-gradient-4);
                }
                .traffic-light-13 {
                    mask: url(#mask-5);
                }
                .traffic-light-14 {
                    fill: url(#linear-gradient-5);
                }
                .traffic-light-15 {
                    mask: url(#mask-6);
                }
                .traffic-light-16 {
                    fill: url(#linear-gradient-6);
                }
                .traffic-light-17 {
                    fill: #464646;
                }
                .traffic-light-18 {
                    opacity: 0.8;
                }
                .traffic-light-19 {
                    filter: url(#luminosity-noclip-6);
                }
                .traffic-light-20 {
                    filter: url(#luminosity-noclip-5);
                }
                .traffic-light-21 {
                    filter: url(#luminosity-noclip-4);
                }
                .traffic-light-22 {
                    filter: url(#luminosity-noclip-2);
                }
                .traffic-light-23 {
                    filter: url(#luminosity-noclip);
                }
            </style>
            <filter
                id="luminosity-noclip"
                x="79.24"
                y="-8574"
                width="147.3"
                height="32766"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-color="#fff" result="bg" />
                <feBlend in="SourceGraphic" in2="bg" />
            </filter>
            <mask
                id="mask"
                x="79.24"
                y="-8574"
                width="147.3"
                height="32766"
                maskUnits="userSpaceOnUse"
            >
                <g class="traffic-light-23" />
            </mask>
            <linearGradient
                id="linear-gradient"
                x1="-503.14"
                y1="-3913.51"
                x2="-424.45"
                y2="-3913.51"
                gradientTransform="translate(4066.4 -329.26) rotate(-90)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" />
            </linearGradient>
            <filter
                id="luminosity-noclip-2"
                x="79.24"
                y="-8574"
                width="147.3"
                height="32766"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-color="#fff" result="bg" />
                <feBlend in="SourceGraphic" in2="bg" />
            </filter>
            <mask
                id="mask-2"
                x="79.24"
                y="-8574"
                width="147.3"
                height="32766"
                maskUnits="userSpaceOnUse"
            >
                <g class="traffic-light-22" />
            </mask>
            <linearGradient
                id="linear-gradient-2"
                x1="-349.97"
                y1="-3913.52"
                x2="-271.28"
                y2="-3913.52"
                gradientTransform="translate(4066.4 32.81) rotate(-90)"
                xlink:href="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-3"
                x1="-198.74"
                y1="-3913.52"
                x2="-120.05"
                y2="-3913.52"
                gradientTransform="translate(4066.4 390.3) rotate(-90)"
                xlink:href="#linear-gradient"
            />
            <radialGradient
                id="Nieuwe_verloopstaal_1"
                cx="4239.64"
                cy="-191.1"
                r="85.14"
                gradientTransform="translate(-38.22 -4066.4) rotate(90)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="red" />
                <stop offset="0.43" stop-color="#fd0000" />
                <stop offset="0.59" stop-color="#f60000" />
                <stop offset="0.7" stop-color="#eb0000" />
                <stop offset="0.79" stop-color="#da0000" />
                <stop offset="0.86" stop-color="#c40000" />
                <stop offset="0.93" stop-color="#a80000" />
                <stop offset="0.99" stop-color="#890000" />
                <stop offset="1" stop-color="#840000" />
            </radialGradient>
            <radialGradient
                id="Nieuwe_verloopstaal_2"
                cx="4449.18"
                cy="-191.1"
                r="85.14"
                gradientTransform="translate(-38.22 -4066.4) rotate(90)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#ffec00" />
                <stop offset="1" stop-color="#f29100" />
            </radialGradient>
            <radialGradient
                id="Nieuwe_verloopstaal_4"
                cx="4655.44"
                cy="-191.1"
                r="85.14"
                gradientTransform="translate(-38.22 -4066.4) rotate(90)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#ac0" />
                <stop offset="0.4" stop-color="#a8cb00" />
                <stop offset="0.55" stop-color="#a1c800" />
                <stop offset="0.65" stop-color="#96c300" />
                <stop offset="0.74" stop-color="#85bc00" />
                <stop offset="0.81" stop-color="#6fb300" />
                <stop offset="0.87" stop-color="#53a700" />
                <stop offset="0.93" stop-color="#339a00" />
                <stop offset="0.98" stop-color="#0f8a00" />
                <stop offset="1" stop-color="#008400" />
            </radialGradient>
            <filter
                id="luminosity-noclip-4"
                x="79.24"
                y="95.19"
                width="147.3"
                height="78.68"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-color="#fff" result="bg" />
                <feBlend in="SourceGraphic" in2="bg" />
            </filter>
            <mask
                id="mask-4"
                x="79.17"
                y="95.44"
                width="147.3"
                height="78.68"
                maskUnits="userSpaceOnUse"
            >
                <g class="traffic-light-21">
                    <g transform="translate(-0.07 0.26)">
                        <g class="traffic-light-1">
                            <path
                                class="traffic-light-2"
                                d="M79.24,168.84c0,1.69.08,3.37.19,5a73.63,73.63,0,0,1,146.92,0c.11-1.66.19-3.34.19-5a73.65,73.65,0,1,0-147.3,0Z"
                            />
                        </g>
                    </g>
                </g>
            </mask>
            <linearGradient
                id="linear-gradient-4"
                x1="-503.14"
                y1="-3913.51"
                x2="-424.45"
                y2="-3913.51"
                gradientTransform="translate(4066.4 -329.26) rotate(-90)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f5f5f5" />
                <stop offset="1" stop-color="#f5f5f5" />
            </linearGradient>
            <filter
                id="luminosity-noclip-5"
                x="79.24"
                y="304.09"
                width="147.3"
                height="78.68"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-color="#fff" result="bg" />
                <feBlend in="SourceGraphic" in2="bg" />
            </filter>
            <mask
                id="mask-5"
                x="79.17"
                y="304.35"
                width="147.3"
                height="78.68"
                maskUnits="userSpaceOnUse"
            >
                <g class="traffic-light-20">
                    <g transform="translate(-0.07 0.26)">
                        <g class="traffic-light-3">
                            <path
                                class="traffic-light-4"
                                d="M79.24,377.74c0,1.69.08,3.37.19,5a73.63,73.63,0,0,1,146.92,0c.11-1.67.19-3.35.19-5a73.65,73.65,0,1,0-147.3,0Z"
                            />
                        </g>
                    </g>
                </g>
            </mask>
            <linearGradient
                id="linear-gradient-5"
                x1="-349.97"
                y1="-3913.52"
                x2="-271.28"
                y2="-3913.52"
                gradientTransform="translate(4066.4 32.81) rotate(-90)"
                xlink:href="#linear-gradient-4"
            />
            <filter
                id="luminosity-noclip-6"
                x="79.24"
                y="510.36"
                width="147.3"
                height="78.68"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-color="#fff" result="bg" />
                <feBlend in="SourceGraphic" in2="bg" />
            </filter>
            <mask
                id="mask-6"
                x="79.17"
                y="510.61"
                width="147.3"
                height="78.68"
                maskUnits="userSpaceOnUse"
            >
                <g class="traffic-light-19">
                    <g transform="translate(-0.07 0.26)">
                        <g class="traffic-light-3">
                            <path
                                class="traffic-light-5"
                                d="M79.24,584c0,1.7.08,3.37.19,5a73.63,73.63,0,0,1,146.92,0c.11-1.67.19-3.34.19-5a73.65,73.65,0,0,0-147.3,0Z"
                            />
                        </g>
                    </g>
                </g>
            </mask>
            <linearGradient
                id="linear-gradient-6"
                x1="-198.74"
                y1="-3913.52"
                x2="-120.05"
                y2="-3913.52"
                gradientTransform="translate(4066.4 390.3) rotate(-90)"
                xlink:href="#linear-gradient-4"
            />
        </defs>
        <title>verkeerslicht_v2</title>
        <g id="Laag_1" data-name="Laag 1">
            <path
                class="traffic-light-6"
                d="M152.89-.26A152.82,152.82,0,0,0,.07,152.56V609.71a152.82,152.82,0,0,0,305.64,0V152.56A152.82,152.82,0,0,0,152.89-.26Z"
                transform="translate(-0.07 0.26)"
            />
            <path
                class="traffic-light-7"
                d="M152.89,732.53A123,123,0,0,1,30.07,609.71V152.56a122.82,122.82,0,1,1,245.64,0V609.71A123,123,0,0,1,152.89,732.53Z"
                transform="translate(-0.07 0.26)"
            />
            <path
                class="traffic-light-8"
                (click)="switchTrafficLight(STATES.Red)"
                d="M152.89,258.38A85.14,85.14,0,1,1,238,173.24,85.14,85.14,0,0,1,152.89,258.38Z"
                transform="translate(-0.07 0.26)"
            />
            <path
                class="traffic-light-9"
                (click)="switchTrafficLight(STATES.Yellow)"
                d="M152.89,467.91A85.14,85.14,0,1,1,238,382.77,85.14,85.14,0,0,1,152.89,467.91Z"
                transform="translate(-0.07 0.26)"
            />
            <path
                class="traffic-light-10"
                (click)="switchTrafficLight(STATES.Green)"
                d="M152.89,674.18A85.14,85.14,0,1,1,238,589,85.14,85.14,0,0,1,152.89,674.18Z"
                transform="translate(-0.07 0.26)"
            />
            <g class="traffic-light-11">
                <path
                    class="traffic-light-12"
                    d="M79.24,168.84c0,1.69.08,3.37.19,5a73.63,73.63,0,0,1,146.92,0c.11-1.66.19-3.34.19-5a73.65,73.65,0,1,0-147.3,0Z"
                    transform="translate(-0.07 0.26)"
                />
            </g>
            <g class="traffic-light-13">
                <path
                    class="traffic-light-14"
                    d="M79.24,377.74c0,1.69.08,3.37.19,5a73.63,73.63,0,0,1,146.92,0c.11-1.67.19-3.35.19-5a73.65,73.65,0,1,0-147.3,0Z"
                    transform="translate(-0.07 0.26)"
                />
            </g>
            <g class="traffic-light-15">
                <path
                    class="traffic-light-16"
                    d="M79.24,584c0,1.7.08,3.37.19,5a73.63,73.63,0,0,1,146.92,0c.11-1.67.19-3.34.19-5a73.65,73.65,0,0,0-147.3,0Z"
                    transform="translate(-0.07 0.26)"
                />
            </g>
            <path
                class="traffic-light-17"
                d="M152.89,273.68a100,100,0,1,1,100-100A100.11,100.11,0,0,1,152.89,273.68Zm0-192a92,92,0,1,0,92,92A92.1,92.1,0,0,0,152.89,81.68Z"
                transform="translate(-0.07 0.26)"
            />
            <path
                class="traffic-light-17"
                d="M152.89,482.78a100,100,0,1,1,100-100A100.11,100.11,0,0,1,152.89,482.78Zm0-192a92,92,0,1,0,92,92A92.1,92.1,0,0,0,152.89,290.78Z"
                transform="translate(-0.07 0.26)"
            />
            <path
                class="traffic-light-17"
                d="M152.89,689a100,100,0,1,1,100-100A100.11,100.11,0,0,1,152.89,689Zm0-192a92,92,0,1,0,92,92A92.1,92.1,0,0,0,152.89,497Z"
                transform="translate(-0.07 0.26)"
            />
        </g>
        <g id="inactive_layer">
            @if (activeState !== STATES.Red) {
            <path
                (click)="switchTrafficLight(STATES.Red)"
                class="traffic-light-18 red"
                d="M152.89,258.38A85.14,85.14,0,1,1,238,173.24,85.14,85.14,0,0,1,152.89,258.38Z"
                transform="translate(-0.07 0.26)"
            />
            } @if (activeState !== STATES.Yellow) {
            <path
                (click)="switchTrafficLight(STATES.Yellow)"
                class="traffic-light-18 yellow"
                d="M152.89,467.91A85.14,85.14,0,1,1,238,382.77,85.14,85.14,0,0,1,152.89,467.91Z"
                transform="translate(-0.07 0.26)"
            />
            } @if (activeState !== STATES.Green) {
            <path
                (click)="switchTrafficLight(STATES.Green)"
                class="traffic-light-18 green"
                d="M152.89,674.18A85.14,85.14,0,1,1,238,589,85.14,85.14,0,0,1,152.89,674.18Z"
                transform="translate(-0.07 0.26)"
            />
            }
        </g>
    </svg>
</ng-template>
